import {
  initialState,
  Actions,
  State,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_ERROR,
  RESET_CURRENT_USER,
} from '../../types/user/get-current-user'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_CURRENT_USER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_CURRENT_USER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_CURRENT_USER:
      return initialState
    default:
      return state
  }
}

export default reducers
